import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthNewPasswordForm } from '@/components/shared/AuthNewPasswordForm/AuthNewPasswordForm';
import { GenericFormScreen } from '@/components/shared/GenericFormScreen/GenericFormScreen';
import { Button } from '@/components/ui/Button/Button';

interface PasswordResetStepProps {
  goToNextStep: () => void;
  goToPreviousStep: (errorMessage?: string) => void;
  username: string;
  code: string;
  persistedPassword?: string;
  persistPassword: (password: string) => void;
}

export const PasswordResetStep = ({ goToNextStep, goToPreviousStep, username, code, persistedPassword, persistPassword }: PasswordResetStepProps) => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotPassword.steps.passwordReset' });

  const [isLoading, setIsLoading] = useState(false);

  return (
    <GenericFormScreen
      title={t('title')}
      description={t('description')}
      rightActionElement={
        <Button type='submit' form='forgot-password-password-reset-form' isLoading={isLoading} disabled={isLoading} aria-busy={isLoading}>
          {t('submit.label')}
        </Button>
      }
    >
      <AuthNewPasswordForm
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
        username={username}
        code={code}
        persistedPassword={persistedPassword}
        persistPassword={persistPassword}
        setIsLoading={setIsLoading}
      />
    </GenericFormScreen>
  );
};
